<app-doc-viewer title="Form" subtitle="Common">
  <app-example-viewer codeFolder="common/form">
    @if (form$ | async; as form) {
      <igo-form
        [form]="form"
        [formData]="data$ | async"
        (submitForm)="onSubmit($event)"
      >
        <igo-form-group [group]="form.groups[0]" />
        <div formButtons class="actions-container">
          <button
            mat-stroked-button
            type="button"
            color="primary"
            (click)="fillForm()"
          >
            Fill Form
          </button>
          <button
            mat-stroked-button
            type="button"
            color="primary"
            (click)="clearForm()"
          >
            Clear Form
          </button>
          <button
            mat-flat-button
            type="submit"
            color="primary"
            [disabled]="submitDisabled"
          >
            Submit
          </button>
        </div>
      </igo-form>
    }
  </app-example-viewer>
</app-doc-viewer>
